const openingHoursSpecification = [
  {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday"],
    "opens": "09:30",
    "closes": "18:00",
  },
  {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": "Friday",
    "opens": "09:30",
    "closes": "17:00",
  },
];

const schema = {
  "@context": "https://schema.org",
  "@type": "LegalService",
  "name": "Arandia Law Firm",
  "image": "https://arandialawfirm.com/og-image.png",
  "@id": "https://arandialawfirm.com",
  "url": "https://arandialawfirm.com",
  "telephone": "+1-212-586-0500",
  "priceRange": "$$",
  "description": "Arandia Law Firm handles immigration law across NY, NJ, and FL, and criminal defense in New York. We provide strategic counsel in English, Spanish, Portuguese, and French.",
  "knowsLanguage": ["en", "es", "pt", "fr"],
  openingHoursSpecification,
  "department": [
    {
      "@type": "LegalService",
      "name": "Arandia Law Firm - New York Office",
      "telephone": "+1-212-586-0500",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "80-02 Kew Gardens Rd, Suite 702",
        "addressLocality": "Kew Gardens",
        "addressRegion": "NY",
        "postalCode": "11415",
        "addressCountry": "US"
      }
    },
    {
      "@type": "LegalService",
      "name": "Arandia Law Firm - New Jersey Office",
      "telephone": "+1-848-388-0660",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "6035 Kennedy Blvd E",
        "addressLocality": "West New York",
        "addressRegion": "NJ",
        "postalCode": "07093",
        "addressCountry": "US"
      }
    },
    {
      "@type": "LegalService",
      "name": "Arandia Law Firm - Florida Office",
      "telephone": "+1-212-586-0500",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "7284 West Palmetto Park Rd, Suite 101",
        "addressLocality": "Boca Raton",
        "addressRegion": "FL",
        "postalCode": "33433",
        "addressCountry": "US"
      }
    }
  ]
};

const LocalBusinessSchema = () => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
  />
);

export default LocalBusinessSchema;
